"use client"

import { Component } from "react"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import { getCurrency } from "../../common/util"
import routes from "../../routes/URL"
import { Box, Button } from "@mui/material"
import PrintIcon from "@mui/icons-material/Print"
import { convertFromRaw } from 'draft-js'
import { stateToHTML } from 'draft-js-export-html'
import Header from "../../components/Header"
import Toast from "../../components/Toast"

class OrderDetailScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hotel_name: "",
      address: "",
      order_id: "",
      order_type: "",
      date: "",
      coupon: "",
      order_status: "",
      currency: "",
      items: [],
      total: "",
      payments: [],
      customer_name: "",
      gst_number: "",
      fssai_number: "",
      printing: false,
      currency: "",
      logo: "",
      hotel_phones: "",
      floor_no: "",
      table_no: "",
      grandTotal: "",
      toast: {
        open: false,
        message: "",
        severity: "message"
      }
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    })
  }

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return
    this.setState({ toast: { ...this.state.toast, open: false } })
  }

  getOrderDetails = async () => {
    const id = this.props.match.params.id
    this.setState({ loading: true, order_id: id })

    const response = await API(this, "get", URL_PATH.OrderHistoryDetail(id))

    this.setState({ loading: false })

    const { status, message, data } = response
    if (status === "success") {
      if (data.order_type !== this.props.match.params.orderType) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''))
        return
      }
    }

    if (status == "error") return this.showToast(message, "error")

    const {
      hotel_name,
      hotel_address,
      hotel_phones,
      order_id,
      order_type,
      date,
      coupon,
      order_status,
      items,
      total,
      payments,
      gst_number,
      fssai_number,
      customer_name,
      payment_method,
      floor_no,
      table_no
    } = data

    const grandTotalItem = payments.find(p => p.key === "Grand Total")
    const grandTotalValue = grandTotalItem?.value || "0.00"

    this.setState({
      gst_number,
      fssai_number,
      customer_name,
      hotel_name,
      address: hotel_address,
      hotel_phones,
      order_id,
      order_type,
      date,
      coupon,
      order_status,
      items,
      total,
      payments,
      payment_method,
      floor_no,
      table_no,
      grandTotal: grandTotalValue
    })
  }

  getHotelDetails = async () => {
    const id = this.props.match.params.id
    this.setState({ loading: true, order_id: id })

    const { status, message, data } = await API(this, "get", URL_PATH.hotelProfile(this.props.selectedHotelId.id))

    this.setState({
      logo: data.logo,
    })
  }

  componentDidMount() {
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug)
    if (!hotel) {
      this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''))
      return
    }
    const currency = getCurrency(this.props.selectedHotelId.currency)
    this.getOrderDetails()
    this.getHotelDetails()
    this.setState({
      currency: currency,
    })
    this.addPrintStyles()
  }

  addPrintStyles = () => {
    const style = document.createElement("style")
    style.id = "print-styles"
    style.innerHTML = `
      @media print {
        body * {
          visibility: hidden;
        }
        #printSection, #printSection * {
          visibility: visible;
        }
        #printSection {
          position: absolute;
          left: 0;
          top: 0;
          width: 80mm;
          max-width: 80mm;
          padding: 10px !important;
          margin: 0 !important;
          color: black !important;
          font-size: 12px !important;
          font-family: 'Poppins', sans-serif !important;
        }
        @page {
          size: auto;
          margin: 0;
        }
        #printSection img {
          max-height: 150px !important;
          max-width: 150px !important;
          height: auto !important;
          width: auto !important;
        }
        .no-print {
          display: none !important;
        }
        .footer-image {
          page-break-inside: avoid;
        }
      }
    `
    document.head.appendChild(style)
  }

  handlePrint = () => {
    const printContent = document.getElementById('printSection').cloneNode(true)
    const iframe = document.createElement('iframe')
    iframe.style.position = 'absolute'
    iframe.style.left = '-9999px'
    iframe.style.width = '80mm'
    iframe.style.border = 'none'

    document.body.appendChild(iframe)

    iframe.onload = () => {
      const currentLang = document.documentElement.lang || 'en'
      iframe.contentDocument.documentElement.lang = currentLang

      const styles = document.querySelectorAll('style, link[rel="stylesheet"]')
      styles.forEach(style => {
        iframe.contentDocument.head.appendChild(style.cloneNode(true))
      })

      iframe.contentDocument.body.appendChild(printContent)

      setTimeout(() => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()

        setTimeout(() => {
          document.body.removeChild(iframe)
        }, 1000)
      }, 500)
    }

    iframe.srcdoc = '<!DOCTYPE html><html><head><title>Receipt</title></head><body></body></html>'
  }

  renderFooterContent = () => {
    if (!this.props.receiptFooter) {
      return (
        <div style={{
          textAlign: "center",
          marginTop: "5px",
          fontStyle: "italic",
          borderTop: "1px dashed #000",
          paddingTop: "10px"
        }}>
          Thank you!<br />
          Please visit us again!
        </div>
      )
    }

    const { content, images } = this.props.receiptFooter

    try {
      const contentState = convertFromRaw(content)
      const htmlContent = stateToHTML(contentState)

      return (
        <div style={{ marginTop: "20px", borderTop: "1px dashed #000", paddingTop: "10px" }}>
          <div 
            dangerouslySetInnerHTML={{ __html: htmlContent }} 
   style={{
          textAlign: "center",
          marginTop: "5px",
          borderTop: "1px dashed #000",
          paddingTop: "10px"
        }}/>
         
          
          {images?.length > 0 && (
            <div style={{ 
              display: "flex", 
              flexWrap: "wrap", 
              justifyContent: "center",
              gap: "10px",
              marginTop: "10px"
            }}>
              {images.map((img, index) => (
                <img
                  key={index}
                  src={`https://static-dev.etableapp.com/${img}`}
                                    // src={`https://static-dev.etableapp.com/receipt_footer_images/1754658608_w41cdmz8ki.png`}

                  
                  // alt={`Footer ${index + 1}`}
                  className="footer-image"
                  style={{
                    maxHeight: img.includes('qr') ? "150px" : "100px",
                    maxWidth: "100%",
                    objectFit: "contain"
                  }}
                />
              ))}
            </div>
          )}
        </div>
      )
    } catch (e) {
      console.error("Error rendering footer:", e)
      return null
    }
  }

  renderItem = (item, index) => {
    const formatSpecialData = (specialItem) => {
      if (!specialItem) return null

      const elements = []

      if (specialItem.variation_data && Object.keys(specialItem.variation_data).length > 0) {
        elements.push(
          <div key="variations" style={{ fontSize: '12px', color: '#555', marginTop: '2px', whiteSpace: 'pre-line' }}>
            {Object.entries(specialItem.variation_data).map(([key, value]) => (
              <div key={key}>
                {key}: {value}
              </div>
            ))}
          </div>
        )
      }

      if (specialItem.add_ons_data) {
        let addonsToRender = []

        if (Array.isArray(specialItem.add_ons_data)) {
          addonsToRender = specialItem.add_ons_data.map(addon => ({
            name: addon.addon_field_name || addon.option_name,
            price: addon.price
          }))
        } else if (typeof specialItem.add_ons_data === 'object') {
          addonsToRender = Object.entries(specialItem.add_ons_data).map(([name, price]) => ({
            name,
            price
          }))
        }

        if (addonsToRender.length > 0) {
          elements.push(
            <div key="addons" style={{ fontSize: '12px', color: '#555', marginTop: '2px', whiteSpace: 'pre-line' }}>
              Add-ons:
              {addonsToRender.map((addon, i) => (
                <div key={i}>
                  + {addon.name} ({this.state.currency}{addon.price})
                </div>
              ))}
            </div>
          )
        }
      }

      if (specialItem.special_request) {
        elements.push(
          <div key="request" style={{ fontSize: '11px', color: '#555', marginTop: '2px', whiteSpace: 'pre-line' }}>
            Special Request: {specialItem.special_request}
          </div>
        )
      }

      return elements
    }

    return (
      <div
        key={index}
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "8px",
        }}
      >
        <div style={{
          flex: "2",
          paddingRight: "10px"
        }}>
          <div style={{ fontWeight: "bold" }}>{item.name}</div>
        
          {item.specialItem && formatSpecialData(item.specialItem)}
        </div>

        <div style={{
          flex: "1",
          display: "flex",
          justifyContent: "space-between",
          minWidth: "120px",
          textAlign: "right"
        }}>
          <div>{this.state.currency}{item.rate.toFixed(2)}</div>
          <div>{item.quantity}</div>
          <div>{this.state.currency}{item.amount.toFixed(2)}</div>
        </div>
      </div>
    )
  }

  renderPaymentDetails = (item, isLast) => {
    if (item.key === "Grand Total") return null

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          margin: "3px 0",
          fontWeight: isLast ? "bold" : "normal"
        }}
      >
        <span>{item.key}</span>
        <span>
          {this.state.currency}{Number.parseFloat(item.value.toString()).toFixed(2)}
        </span>
      </div>
    )
  }

  render() {
    const finalTotal = this.state.grandTotal || "0.00"
    const phones = Array.isArray(this.state.hotel_phones) ? this.state.hotel_phones.join(", ") : this.state.hotel_phones

    return (
      <div className="container-fluid">
        <Header title="Order " />
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "0px",
            boxShadow: "none",
            padding: "10px",
            width: "80mm",
            maxWidth: "80mm",
            margin: "0 auto",
            color: "black",
            fontFamily: "'Poppins', sans-serif",
            fontSize: "12px",
            lineHeight: "1.2"
          }}
          id="printSection"
        >
          {/* Logo */}
          <Box sx={{ textAlign: "center", marginBottom: "10px" }}>
            {this.state.logo && (
              <div style={{ marginBottom: "10px" }}>
                <img
                  src={this.state.logo || "/placeholder.svg"}
                  alt="Business Logo"
                  style={{
                    maxHeight: "200px",
                    maxWidth: "200px",
                    objectFit: "cover",
                  }}
                />
              </div>
            )}

            {/* Hotel Info */}
            <div style={{ fontWeight: "bold", fontSize: "18px", marginBottom: "5px" }}>
              {this.state.hotel_name}
            </div>
            {this.state.address && (
              <div style={{ marginBottom: "3px" }}>
                {this.state.address}
              </div>
            )}
            {phones && (
              <div style={{ marginBottom: "3px" }}>
                Ph. {phones}
              </div>
            )}
            {this.state.gst_number && (
              <div>
                GSTIN: {this.state.gst_number}
              </div>
            )}
            {this.state.fssai_number && (
              <div style={{ marginBottom: "10px" }}>
                FSSAI NO: {this.state.fssai_number}
              </div>
            )}
          </Box>

          {/* Order Info */}
          <Box sx={{
            margin: "10px 0",
            borderTop: "1px dashed #000",
            borderBottom: "1px dashed #000",
            padding: "5px 0"
          }}>
            <div style={{ marginBottom: "3px" }}>
              <span style={{fontWeight:"bold"}}>Bill To:</span>  {this.state.customer_name}
            </div>
            <div style={{ marginBottom: "3px" }}>
              <span style={{fontWeight:"bold"}}>Order No:</span>  {this.state.order_id}
            </div>
            <div style={{ marginBottom: "3px" }}>
              <span style={{fontWeight:"bold"}}>Type: </span>
              <span style={{ textTransform: 'capitalize' }}>
                {this.state.order_type}
              </span>
            </div>
            <div style={{ marginBottom: "3px" }}>
              <span style={{fontWeight:"bold"}}>Date:</span>  {this.state.date}
            </div>
            {(this.state.floor_no || this.state.table_no) && (
              <div style={{ fontWeight: "bold", marginTop: "3px" }}>
                {this.state.floor_no} | {this.state.table_no}
              </div>
            )}
          </Box>

          {/* Items Header */}
          <div style={{
            fontWeight: "bold",
            margin: "10px 0 5px 0",
            textAlign: "center"
          }}>
            Order Items
          </div>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            fontWeight: "bold",
            borderBottom: "1px solid #000",
            paddingBottom: "3px",
            marginBottom: "5px"
          }}>
            <div>ITEM</div>
            <div style={{ display: "flex", justifyContent: "space-between", minWidth: "120px" }}>
              <div>RATE</div>
              <div>QTY</div>
              <div>AMT</div>
            </div>
          </div>

          {/* Items List */}
          <div>
            {this.state.items.map((item, index) => this.renderItem(item, index))}
          </div>

          {/* Payment Summary */}
          <div style={{
            fontWeight: "bold",
            margin: "10px 0 5px 0",
            textAlign: "center"
          }}>
            Payment Summary
          </div>
          <div>
            {this.state.payments.map((item, index) =>
              this.renderPaymentDetails(item, index === this.state.payments.length - 1)
            )}
          </div>

          {/* Grand Total */}
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            borderTop: "1px dashed #000",
            padding: "6px 0",
            fontWeight: "bold"
          }}>
            <div className="notranslate">Grand Total</div>
            <div className="notranslate">
              {this.state.currency}{Number.parseFloat(finalTotal.toString()).toFixed(2)}
            </div>
          </div>

          {/* Payment Mode */}
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            borderTop: "1px dashed #000",
            paddingTop: "6px",
          }}>
            <div>Payment Mode</div>
            <div style={{ textTransform: "uppercase" }}>
              {this.state.payment_method}
            </div>
          </div>

          {/* Dynamic Footer */}
          {this.renderFooterContent()}
        </Box>

        {/* Print Button */}
        <Box sx={{ textAlign: "center", marginTop: "20px" }} className="no-print">
          <Button
            variant="contained"
            onClick={this.handlePrint}
            startIcon={<PrintIcon />}
            sx={{
              backgroundColor: "#FFC857",
              fontWeight: "700",
              color: "black",
              "&:hover": {
                backgroundColor: "#BB0A21",
                color: "white",
              },
            }}
          >
            Print Receipt
          </Button>
        </Box>
        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          onClose={this.handleCloseToast}
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    hotels: state.hotels,
    selectedHotelId: state.selectedHotelId,
    receiptFooter: state.receiptFooter
  }
}

export default redux(OrderDetailScreen)

// "use client"

// import { Component } from "react"
// import API, { URL_PATH } from "../../services/API"
// import redux from "../../common/Redux"
// import { getCurrency } from "../../common/util"
// import routes from "../../routes/URL"
// import { Box, Button } from "@mui/material"
// import PrintIcon from "@mui/icons-material/Print"

// import Header from "../../components/Header"
// import Toast from "../../components/Toast"

// class OrderDetailScreen extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       hotel_name: "",
//       address: "",
//       order_id: "",
//       order_type: "",
//       date: "",
//       coupon: "",
//       order_status: "",
//       currency: "",
//       items: [],
//       total: "",
//       payments: [],
//       customer_name: "",
//       gst_number: "",
//       fssai_number:"",
//       printing: false,
//       currency: "",
//       logo: "",
//       hotel_phones: "",
//       floor_no: "",
//       table_no: "",
//       grandTotal: "", // Add this for storing grand total separately
//       toast: {
//         open: false,
//         message: "",
//         severity: "message"
//       }
//     }
//   }

//   showToast = (message, severity = "success") => {
//     this.setState({
//       toast: {
//         open: true,
//         message,
//         severity
//       }
//     });
//   };

//   handleCloseToast = (event, reason) => {
//     if (reason === 'clickaway') return;
//     this.setState({ toast: { ...this.state.toast, open: false } });
//   };

//   getOrderDetails = async () => {
//     const id = this.props.match.params.id
//     this.setState({ loading: true, order_id: id })

//     const response = await API(this, "get", URL_PATH.OrderHistoryDetail(id))

//     this.setState({ loading: false })

//     const { status, message, data } = response
//     if (status === "success") {
//     if (data.order_type !== this.props.match.params.orderType) {
//         this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
//         return;
//       }
//     }

//     if (status == "error") return this.showToast(message, "error");

//     const {
//       hotel_name,
//       hotel_address,
//       hotel_phones,
//       order_id,
//       order_type,
//       date,
//       coupon,
//       order_status,
//       items,
//       total,
//       payments,
//       gst_number,
//       fssai_number,
//       customer_name,
//       payment_method,
//       floor_no,
//       table_no
//     } = data

//     // Extract grand total value separately to avoid translation issues
//     const grandTotalItem = payments.find(p => p.key === "Grand Total");
//     const grandTotalValue = grandTotalItem?.value || "0.00";

//     this.setState({
//       gst_number,
//       fssai_number,
//       customer_name,
//       hotel_name,
//       address: hotel_address,
//       hotel_phones,
//       order_id,
//       order_type,
//       date,
//       coupon,
//       order_status,
//       items,
//       total,
//       payments,
//       payment_method,
//       floor_no,
//       table_no,
//       grandTotal: grandTotalValue // Store grand total separately
//     })
//   }

//   getHotelDetails = async () => {
//     const id = this.props.match.params.id
//     this.setState({ loading: true, order_id: id })

//     const { status, message, data } = await API(this, "get", URL_PATH.hotelProfile(this.props.selectedHotelId.id))

//     this.setState({
//       logo: data.logo,
//     })
//   }

//   componentDidMount() {
//        const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
//     if (!hotel) {
//         this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
//         return;
//     }
//     const currency = getCurrency(this.props.selectedHotelId.currency)
//     this.getOrderDetails()
//     this.getHotelDetails()
//     this.setState({
//       currency: currency,
//     })
//     this.addPrintStyles()
//   }

//  addPrintStyles = () => {
//   const style = document.createElement("style");
//   style.id = "print-styles";
//   style.innerHTML = `
//     @media print {
//       body * {
//         visibility: hidden;
//       }
//       #printSection, #printSection * {
//         visibility: visible;
//       }
//       #printSection {
//         position: absolute;
//         left: 0;
//         top: 0;
//         width: 80mm;
//         max-width: 80mm;
//         padding: 10px !important;
//         margin: 0 !important;
//         color: black !important;
//         font-size: 12px !important;
//         font-family: 'Poppins', sans-serif !important;
//       }
//       @page {
//         size: auto;
//         margin: 0;
//       }
//       #printSection img {
//         max-height: 150px !important;
//         max-width: 150px !important;
//         height: auto !important;
//         width: auto !important;
//       }
//       .no-print {
//         display: none !important;
//       }
//     }
//   `;
//   document.head.appendChild(style);
// };

//   handlePrint = () => {
//     const printContent = document.getElementById('printSection').cloneNode(true);
//     const iframe = document.createElement('iframe');
//     iframe.style.position = 'absolute';
//     iframe.style.left = '-9999px';
//     iframe.style.width = '80mm';
//     iframe.style.border = 'none';

//     document.body.appendChild(iframe);

//     iframe.onload = () => {
//       const currentLang = document.documentElement.lang || 'en';
//       iframe.contentDocument.documentElement.lang = currentLang;

//       const styles = document.querySelectorAll('style, link[rel="stylesheet"]');
//       styles.forEach(style => {
//         iframe.contentDocument.head.appendChild(style.cloneNode(true));
//       });

//       iframe.contentDocument.body.appendChild(printContent);

//       setTimeout(() => {
//         iframe.contentWindow.focus();
//         iframe.contentWindow.print();

//         setTimeout(() => {
//           document.body.removeChild(iframe);
//         }, 1000);
//       }, 500);
//     };

//     iframe.srcdoc = '<!DOCTYPE html><html><head><title>Receipt</title></head><body></body></html>';
//   };

//   renderItem = (item, index) => {
//     const formatSpecialData = (specialItem) => {
//       if (!specialItem) return null;

//       const elements = [];

//       if (specialItem.variation_data && Object.keys(specialItem.variation_data).length > 0) {
//         elements.push(
//           <div key="variations" style={{ fontSize: '12px', color: '#555', marginTop: '2px', whiteSpace: 'pre-line' }}>
//             {Object.entries(specialItem.variation_data).map(([key, value]) => (
//               <div key={key}>
//                 {key}: {value}
//               </div>
//             ))}
//           </div>
//         );
//       }

//       if (specialItem.add_ons_data) {
//         let addonsToRender = [];

//         if (Array.isArray(specialItem.add_ons_data)) {
//           addonsToRender = specialItem.add_ons_data.map(addon => ({
//             name: addon.addon_field_name || addon.option_name,
//             price: addon.price
//           }));
//         } else if (typeof specialItem.add_ons_data === 'object') {
//           addonsToRender = Object.entries(specialItem.add_ons_data).map(([name, price]) => ({
//             name,
//             price
//           }));
//         }

//         if (addonsToRender.length > 0) {
//           elements.push(
//             <div key="addons" style={{ fontSize: '12px', color: '#555', marginTop: '2px', whiteSpace: 'pre-line' }}>
//               Add-ons:
//               {addonsToRender.map((addon, i) => (
//                 <div key={i}>
//                   + {addon.name} ({this.state.currency}{addon.price})
//                 </div>
//               ))}
//             </div>
//           );
//         }
//       }

//       if (specialItem.special_request) {
//         elements.push(
//           <div key="request" style={{ fontSize: '11px', color: '#555', marginTop: '2px', whiteSpace: 'pre-line' }}>
//             Special Request: {specialItem.special_request}
//           </div>
//         );
//       }

//       return elements;
//     };

//     return (
//       <div
//         key={index}
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           marginBottom: "8px",
//         }}
//       >
//         <div style={{
//           flex: "2",
//           paddingRight: "10px"
//         }}>
//           <div style={{ fontWeight: "bold" }}>{item.name}</div>
        
//           {item.specialItem && formatSpecialData(item.specialItem)}
//         </div>

//         <div style={{
//           flex: "1",
//           display: "flex",
//           justifyContent: "space-between",
//           minWidth: "120px",
//           textAlign: "right"
//         }}>
//           <div>{this.state.currency}{item.rate.toFixed(2)}</div>
//           <div>{item.quantity}</div>
//           <div>{this.state.currency}{item.amount.toFixed(2)}</div>
//         </div>
//       </div>
//     );
//   };

//   renderPaymentDetails = (item, isLast) => {
//     // Skip Grand Total in payment details as we show it separately
//     if (item.key === "Grand Total") return null;

//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           margin: "3px 0",
//           fontWeight: isLast ? "bold" : "normal"
//         }}
//       >
//         <span>{item.key}</span>
//         <span>
//           {this.state.currency}{Number.parseFloat(item.value.toString()).toFixed(2)}
//         </span>
//       </div>
//     )
//   }

//   render() {
//     // Use the stored grandTotal value instead of searching through payments
//     const finalTotal = this.state.grandTotal || "0.00";
//     const phones = Array.isArray(this.state.hotel_phones) ? this.state.hotel_phones.join(", ") : this.state.hotel_phones;

//     return (
//       <div className="container-fluid">
//         <Header title="Order " />
//         <Box
//           sx={{
//             backgroundColor: "white",
//             borderRadius: "0px",
//             boxShadow: "none",
//             padding: "10px",
//             width: "80mm",
//             maxWidth: "80mm",
//             margin: "0 auto",
//             color: "black",
//             fontFamily: "'Poppins', sans-serif",
//             fontSize: "12px",
//             lineHeight: "1.2"
//           }}
//           id="printSection"
//         >
//           {/* Logo */}
//           <Box sx={{ textAlign: "center", marginBottom: "10px" }}>
//             {this.state.logo && (
//               <div style={{ marginBottom: "10px" }}>
//                 <img
//                   src={this.state.logo || "/placeholder.svg"}
//                   alt="Business Logo"
//                   style={{
//                     maxHeight: "200px",
//                     maxWidth: "200px",
//                     objectFit: "cover",
                  
//                   }}
//                 />
//               </div>
//             )}

//             {/* Hotel Info */}
//             <div style={{ fontWeight: "bold", fontSize: "18px", marginBottom: "5px" }}>
//               {this.state.hotel_name}
//             </div>
//             {this.state.address && (
//               <div style={{ marginBottom: "3px" }}>
//                 {this.state.address}
//               </div>
//             )}
//             {phones && (
//               <div style={{ marginBottom: "3px" }}>
//                 Ph. {phones}
//               </div>
//             )}
//             {this.state.gst_number && (
//               <div >
//                 GSTIN: {this.state.gst_number}
//               </div>
//             )}
//             {this.state.fssai_number && (
//               <div style={{ marginBottom: "10px" }}>
//                 FSSAI NO: {this.state.fssai_number}
//               </div>
//             )}
//           </Box>

//           {/* Order Info */}
//           <Box sx={{
//             margin: "10px 0",
//             borderTop: "1px dashed #000",
//             borderBottom: "1px dashed #000",
//             padding: "5px 0"
//           }}>
//             <div style={{ marginBottom: "3px" }}>
//              <span style={{fontWeight:"bold"}}>Bill To:</span>  {this.state.customer_name}
//           </div>
//             <div style={{ marginBottom: "3px" }}>
//              <span style={{fontWeight:"bold"}}>Order No:</span>  {this.state.order_id}
//             </div>
//             <div style={{ marginBottom: "3px" }}>
//             <span style={{fontWeight:"bold"}}>  Type: </span><span style={{ textTransform: 'capitalize' }}>
//                 {this.state.order_type}
//               </span>

//             </div>
//             <div style={{ marginBottom: "3px" }}>
//              <span style={{fontWeight:"bold"}}>Date:</span>  {this.state.date}
//             </div>
//             {(this.state.floor_no || this.state.table_no) && (
//               <div style={{ fontWeight: "bold", marginTop: "3px" }}>
//                 {this.state.floor_no} | {this.state.table_no}
//               </div>
//             )}
//           </Box>

//           {/* Items Header */}
//           <div style={{
//             fontWeight: "bold",
//             margin: "10px 0 5px 0",
//             textAlign: "center"
//           }}>
//             Order Items
//           </div>
//           <div style={{
//             display: "flex",
//             justifyContent: "space-between",
//             fontWeight: "bold",
//             borderBottom: "1px solid #000",
//             paddingBottom: "3px",
//             marginBottom: "5px"
//           }}>
//             <div>ITEM</div>
//             <div style={{ display: "flex", justifyContent: "space-between", minWidth: "120px" }}>
//               <div>RATE</div>
//               <div>QTY</div>
//               <div>AMT</div>
//             </div>
//           </div>

//           {/* Items List */}
//           <div>
//             {this.state.items.map((item, index) => this.renderItem(item, index))}
//           </div>

//           {/* Payment Summary */}
//           <div style={{
//             fontWeight: "bold",
//             margin: "10px 0 5px 0",
//             textAlign: "center"
//           }}>
//             Payment Summary
//           </div>
//           <div>
//             {this.state.payments.map((item, index) =>
//               this.renderPaymentDetails(item, index === this.state.payments.length - 1)
//             )}
//           </div>

//           {/* Grand Total - Use stored value with notranslate class */}
//           <div style={{
//             display: "flex",
//             justifyContent: "space-between",
//             borderTop: "1px dashed #000",
//             padding: "6px 0",
//             fontWeight: "bold"
//           }}>
//             <div className="notranslate">Grand Total</div>
//             <div className="notranslate">
//               {this.state.currency}{Number.parseFloat(finalTotal.toString()).toFixed(2)}
//             </div>
//           </div>

//           {/* Payment Mode */}
//           <div style={{
//             display: "flex",
//             justifyContent: "space-between",
//             borderTop: "1px dashed #000",
//             paddingTop: "6px",
//             // marginBottom: "10px"
//           }}>
//             <div>Payment Mode</div>
//             <div style={{ textTransform: "uppercase" }}>
//               {this.state.payment_method}
//             </div>
//           </div>

//           {/* Footer */}
//           <div style={{
//             textAlign: "center",
//             marginTop: "5px",
//             fontStyle: "italic",
//             borderTop: "1px dashed #000",
//             paddingTop: "10px"
//           }}>
//             Thank you!<br />
//             Please visit us again!
//           </div>
//         </Box>

//         {/* Print Button */}
//         <Box sx={{ textAlign: "center", marginTop: "20px" }} className="no-print">
//           <Button
//             variant="contained"
//             onClick={this.handlePrint}
//             startIcon={<PrintIcon />}
//             sx={{
//               backgroundColor: "#FFC857",
//               fontWeight: "700",
//               color: "black",
//               "&:hover": {
//                 backgroundColor: "#BB0A21",
//                 color: "white",
//               },
//             }}
//           >
//             Print Receipt
//           </Button>
//         </Box>
//         <Toast
//           open={this.state.toast.open}
//           message={this.state.toast.message}
//           severity={this.state.toast.severity}
//           onClose={this.handleCloseToast}
//         />
//       </div>
//     )
//   }
// }

// export default redux(OrderDetailScreen)